module.exports = __webpack_public_path__ + "media/images/badges/food-security-production-100-0bfd1ead1684405bbdcd5bc90316d47f.svg";